import React from 'react'
import BedListTable from './Components/BedListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const RoomFacilitesDetailList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Bad List</HeadingOne>
          <AddItemBtn url="add-bed" title="Add Bed" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <BedListTable />
      </div>
    </PageBody>
  );
};

export default RoomFacilitesDetailList;
